export { isAndroid, isIos, isIE } from './user-agent';
